import type { ja } from './lang-ja';
import { LangComEn } from '@/locales/lang-com-en';
export const en: typeof ja = {
  com: LangComEn,
  seo: {
    title: 'INSPIRE LLC > Contact us',
    description: `[INSPIRE LLC] Professional Guild of the Automotive Distribution Industry`,
    keywords: `INSPIRE LLC,cars,Automobile,export, trade ,Used Car,vehicle,tokyo,Japan,application development,`,
  },
  title: `CONTACT US`,
  formLabel: {
    name: `Name`,
    company: `Company name.`,
    email: `E-Mail`,
    tel: `Tel`,
    message: `Message`,
    check: `I agree to the above privacy policy`,
    checkBtn: `Send Message`,
    requireMessage: 'Field is required',
    emailError: 'Please enter your email address',
  },
  checkModal: {
    title: 'Confirmation of transmitted content',
    note: 'Are you sure you want to submit this form?',
    send: 'Send Message',
  },
  requestSend: {
    connectionError: 'Internet error.',
    requestError: 'Failed to send request',
    requestCompleted: 'Message Sending Completed',
  },
  PrivacyPolicy: {
    title: `Privacy Policy`,
    subTitle: `INSPIRE LLC (hereinafter referred to as "INSPIRE") has established the following privacy policy, built a system of personal information protection, and promoted the protection of personal information by ensuring that all employees recognize the importance of personal information protection and take appropriate measures to protect it,
    We will promote the protection of personal information by having all employees recognize the importance of protecting personal information and by ensuring that all employees are fully aware of the importance of protecting personal information and their efforts.`,
    r1: {
      title: `Personal information management.`,
      text: `In order to keep customers' personal information accurate and up-to-date and to prevent unauthorized access to, loss, damage, falsification, or leakage of personal information, we take necessary measures such as maintaining a security system, developing a management system, and providing thorough employee training, and we implement safety measures and strictly manage personal information.`,
    },
    r2: {
      title: `Purpose of use of personal information`,
      text: `Personal information received from customers will be used to send e-mails and materials to customers in order to contact them and answer their questions about our business.`,
    },
    r3: {
      title: `Prohibition of disclosure or provision of personal information to third parties`,
      text: `We will appropriately manage the personal information we receive from our customers and will not disclose personal information to third parties except in the following cases`,
      list1: `When the customer has given consent`,
      list2: `When disclosing information to contractors to whom we outsource our services in order to provide services requested by the customer.`,
      list3: `When disclosure is required by law`,
    },
    r4: {
      title: `Security measures for personal information`,
      text: `We take all possible security measures to ensure the accuracy and safety of personal information.`,
    },
    r5: {
      title: `Inquiry of the person in question`,
      text: `If a customer wishes to inquire about, correct, or delete his/her own personal information, we will respond to the request after confirming the identity of the customer.`,
    },
    r6: {
      title: `Compliance with and review of laws, regulations, and norms`,
      text: `We will comply with Japanese laws, regulations, and other norms applicable to personal information in our possession, and will review and improve the contents of this policy as appropriate.`,
    },
    r7: {
      title: `For inquiries regarding our privacy policy, please contact`,
      text: `For inquiries regarding our handling of personal information, please contact the following`,
    },
    info: {
      name: 'INSPIRE LLC',
      address: '3-11-7 Higashi-tateishi Katsushika-ku Tokyo 124-0013 JAPAN',
      mail: 'E-Mail',
    },
  },
};
